import { MenuRoute, MenuTemplate } from '../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the Project module.
 * Only static (non-parameterized) routes are listed — `:id` routes are reachable from these landing pages.
 */
export const PROJECT_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/projects/list',
    labelKey: 'Project.list',
    icon: '/assets/tablerIcons/outline/list.svg',
    moduleId: 40,
    groupLabelKey: 'MenuRoutes.group.projectViews'
  },
  {
    path: '/projects/overview',
    labelKey: 'Project.overview',
    icon: '/assets/tablerIcons/outline/layout-dashboard.svg',
    moduleId: 40,
    groupLabelKey: 'MenuRoutes.group.projectViews'
  },
  {
    path: '/projects/portfolio-gantt',
    labelKey: 'Project.portfolioGantt',
    icon: '/assets/tablerIcons/outline/timeline.svg',
    moduleId: 40,
    groupLabelKey: 'MenuRoutes.group.projectViews'
  },
  {
    path: '/projects/my-tasks',
    labelKey: 'Project.myTasks',
    icon: '/assets/tablerIcons/outline/checklist.svg',
    moduleId: 40,
    groupLabelKey: 'MenuRoutes.group.projectTasks'
  },
  {
    path: '/projects/task-overview',
    labelKey: 'Project.taskOverview',
    icon: '/assets/tablerIcons/outline/clipboard-list.svg',
    moduleId: 40,
    groupLabelKey: 'MenuRoutes.group.projectTasks'
  }
];

/**
 * Default menu template for the Project module (moduleId=40).
 * Used by `POST /api/MenuManagement/sync-from-template/40` to idempotently UPSERT
 * Menu1/Menu2 rows for a new tenant. UPSERT is keyed on (moduleID, AngularPageLink),
 * with fallback to (moduleID, trimmed name) for the grouping Menu1 root that has no path.
 */
export const PROJECT_MENU_TEMPLATE: MenuTemplate = {
  moduleId: 40,
  roots: [
    {
      name: 'PROSJEKTER',
      path: '',
      icon: '/assets/tablerIcons/outline/folder.svg',
      legacyLink: '?mod=40',
      children: [
        {
          name: 'Prosjektliste',
          path: '/projects/list',
          icon: '/assets/tablerIcons/outline/list.svg'
        },
        {
          name: 'Oversikt',
          path: '/projects/overview',
          icon: '/assets/tablerIcons/outline/layout-dashboard.svg'
        },
        {
          name: 'Portefølje-Gantt',
          path: '/projects/portfolio-gantt',
          icon: '/assets/tablerIcons/outline/timeline.svg'
        },
        {
          name: 'Mine oppgaver',
          path: '/projects/my-tasks',
          icon: '/assets/tablerIcons/outline/checklist.svg'
        },
        {
          name: 'Oppgaveoversikt',
          path: '/projects/task-overview',
          icon: '/assets/tablerIcons/outline/clipboard-list.svg'
        }
      ]
    }
  ]
};
